<template>
  <div class="container">
    <header-app
      :title="$t('Location')"
      class="header-brand"
      link="basket"
    ></header-app>
    <br />
    <br />
    <wrap type="small">
      <loading-location v-if="loading"></loading-location>
      <div class="center text-center">
        <button
          type="button"
          class="btn btn btn-outline-secondary btn-lg buton_location"
          v-if="meta_location.id > 0"
          @click="backButton(meta_location)"
        >
          <base-icon icon_name="arrow-left-circle" />
          {{ meta_location.title }}
        </button>
        <template v-if="parentLocation.length > 0">
          <button
            type="button"
            class="btn btn btn-light shadow-sm btn-lg buton_location"
            :class="{ selected: selectedLocation.id === child.id }"
            v-for="child in parentLocation"
            :key="`${child.id}_${child.title}`"
            @click="getChild(child)"
          >
            {{ child.title }}
          </button>
        </template>

        <br />
        <br />
        <div class="wrap-botttom-action">
          <button
            type="button"
            @click="submit()"
            class="btn btn-brand shadow-sm btn-lg btn-block"
          >
            <base-icon icon_name="send" />
            {{ $t("send_to_location") }} {{ selectedLocation.title }}
          </button>
        </div>
      </div>
    </wrap>
  </div>
</template>

<script>
import store from "@/store";
export default {
  middleware: ["auth", "location"],
  data() {
    return {
      parentLocation: [],
      meta_location: {},
      selectedLocation: {},
      error: false,
    };
  },
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  computed: {
    locations() {
      return store.getters["location/locations"];
    },
    loading() {
      return store.getters["location/loading"];
    },
    orders() {
      return store.getters["order/order"];
    },
    order_loading() {
      return store.getters["order/loading"];
    },
    state_order() {
      return store.getters["order/state_order"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let data = {
        type_id: this.hotel.id,
        type: this.hotelType,
      };
      await store.dispatch("location/getLocations", data);

      if (this.locations) {
        let data = _.filter(this.locations, function (el) {
          return el.parent_id === 0;
        });
        this.parentLocation = data;
      }
    },
    getChild(child) {
      let data = _.filter(this.locations, function (el) {
        return el.parent_id === child.id;
      });
      if (!data.length > 0) {
        this.selectedLocation = child;
        return;
      }
      this.parentLocation = data;
      this.meta_location = child;
    },
    backButton(child) {
      let data = _.filter(this.locations, function (el) {
        return el.parent_id === child.parent_id;
      });
      if (!data.length > 0) return;
      this.parentLocation = data;
      var parent_id = 0;
      if (child.parent_id === 0) {
        parent_id = child.id;
      } else {
        parent_id = child.parent_id;
      }
      // find next parent
      var previousParent = _.find(this.locations, function (el) {
        return el.id === parent_id;
      });
      if (child.parent_id === 0) {
        this.meta_location = [];
      } else this.meta_location = previousParent;
    },
    async submit() {
      if (this.selectedLocation.id) {
        await store.dispatch("order/submitPendingOrder", this.selectedLocation);
        if (this.state_order) {
          this.$store.dispatch("order/clearOrder");
          this.$router.push({ name: "ordercompleted" });
        }
      }
    },
  },
};
</script> 